// Generated by scripts/pull-catalogue.ts from D1 — do not edit by hand.
//
// This is the category list as of the last pull: the offline fallback the storefront
// renders when /api/bootstrap is unreachable. Regenerate with `npm run db:pull`.
import type { Category } from '../types'

export let CATEGORIES: Category[] = [
  {
    id: "llaqe",
    slug: "llak",
    name: { sq: "Llak", en: "Clear coats" },
    blurb: {
      sq: "Llakë profesional për rifiniturë automobilistike, të disponueshme në versione standard, premium, super-fast dhe matte.",
      en: "Professional automotive clear coats available in standard, premium, super-fast and matte versions.",
    },
  },
  {
    id: "hollues",
    slug: "hardener-thinner",
    name: { sq: "Katalit & Dylen", en: "Hardeners & Thinners" },
    blurb: {
      sq: "Katalizatorë dhe hollues profesionalë për sistemet e rifiniturës automobilistike, të projektuar për përzierje të saktë, tharje të kontrolluar dhe aplikim optimal të llakut dhe bojës.",
      en: "Professional hardeners and thinners for automotive refinishing systems, designed for accurate mixing, controlled curing and optimal application of clear coats and paints.",
    },
  },
  {
    id: "astar",
    slug: "astar",
    name: { sq: "Astar", en: "Primer" },
    blurb: {
      sq: "Astarë profesionalë për përgatitjen e sipërfaqeve në rifiniturën automobilistike, me mbushje të mirë, aderencë të fortë dhe smerilim të lehtë para lyerjes.",
      en: "Professional automotive primers for surface preparation, offering good filling power, strong adhesion and easy sanding before painting.",
    },
  },
  {
    id: "stuko",
    slug: "stuko",
    name: { sq: "Stuko", en: "Putty" },
    blurb: {
      sq: "Stuko profesionale për mbushjen, nivelimin dhe riparimin e defekteve të sipërfaqes. E lehtë për t’u aplikuar dhe smeriluar.",
      en: "Professional body fillers for filling, levelling and repairing surface imperfections on vehicle bodywork. Easy to apply and sand.",
    },
  },
  {
    id: "masking",
    slug: "maskim-dhe-pergatitje",
    name: { sq: "Izolim & përgatitje", en: "Masking & prep" },
    blurb: {
      sq: "Produkte për izolimin, maskimin dhe përgatitjen e sipërfaqeve para lyerjes, për punë më të pastra dhe rezultate më të sakta në rifiniturën automobilistike.",
      en: "Products for masking, protection and surface preparation before painting, helping achieve cleaner work and more precise automotive refinishing results.",
    },
  },
  {
    id: "polish",
    slug: "pasta-dhe-lustrim",
    name: { sq: "Pasta & lustrim", en: "Polishes & compounds" },
    blurb: {
      sq: "Pasta abrasive dhe produkte lustrimi për korrigjimin, rafinimin dhe rikthimin e shkëlqimit të sipërfaqeve të lyera dhe plastike.",
      en: "Abrasive compounds and polishing products for correcting, refining and restoring gloss on painted and plastic surfaces.",
    },
  },
  {
    id: "aditive-ndihmese",
    slug: "aditive-ndihmese",
    name: { sq: "Aditivë ndihmës", en: "Auxiliary additives" },
    blurb: {
      sq: "Aditivë profesionalë për rregullimin dhe përmirësimin e performancës së rifinitures.",
      en: "Professional additives for adjusting and improving the performance of refinishing.",
    },
  },
]

export let CATEGORY_BY_ID = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c]),
) as Record<Category['id'], Category>

export let CATEGORY_BY_SLUG = Object.fromEntries(
  CATEGORIES.map((c) => [c.slug, c]),
) as Record<string, Category | undefined>

/** Counterpart to hydrateProducts — see the note in src/data/products.ts. */
export function hydrateCategories(categories: Category[]): void {
  CATEGORIES = categories
  CATEGORY_BY_ID = Object.fromEntries(categories.map((c) => [c.id, c])) as Record<
    Category['id'],
    Category
  >
  CATEGORY_BY_SLUG = Object.fromEntries(categories.map((c) => [c.slug, c])) as Record<
    string,
    Category | undefined
  >
}
